<div class="fab dekstop-width-limiter {{ style }}" [title]="title | translate" [routerLink]="routerLink">
  @if (!icon) {
    <img src="./assets/images/FAB.svg">
  }
  @if (icon) {
    <div class="icon"><mat-icon >{{icon}}</mat-icon></div>
  }
  <span>{{title | translate}}</span>
</div>
